import { BaseEvent, HistoryMessageItem, useIM, MessageIncomingEvent, MessageOutgoingEvent } from '@wui/im'

import { chatModel } from '@/entities/messages/chat'

import { pServedIsRoom } from '@/shared/utils/uri'

import { useNotInHistoryMessagesStore } from './'

export const loadMessage = async (pServed: string, eventId: number): Promise<HistoryMessageItem | undefined> => {
  try {
    const { requestChatHistory } = useIM()
    const { events = [] } = await requestChatHistory({
      pServed,
      messagesLimit: 1,
      cursorEventId: eventId,
      isConference: pServedIsRoom(pServed),
    })

    if (events[0]) {
      return {
        ...events[0],
      }
    }
    return
  } catch (e) {
    console.error(e)
    return
  }
}

export const fetchMessage = async <T extends BaseEvent = BaseEvent>(eventId: number, pServed: string): Promise<HistoryMessageItem<T> | undefined> => {
  try {
    const { findById } = chatModel.useChatMessageStore()
    const { getMessageByEventId, addMessage } = useNotInHistoryMessagesStore()
    let event = findById(eventId)

    if (!event) {
      event = getMessageByEventId(eventId)
      if (!event) {
        event = await loadMessage(pServed, eventId)

        if (event && event.eventId) {
          addMessage(event.eventId, event as HistoryMessageItem<MessageIncomingEvent | MessageOutgoingEvent>)
        }
      }
    }

    return <HistoryMessageItem<T> | undefined>event
  } catch (e) {
    console.error(e)
    return
  }
}
